import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { ErroNotificacaoService } from 'src/app/erro-notificacao.service';

@Component({
  selector: 'app-descricao-convenio',
  templateUrl: './descricao-convenio.component.html',
  styleUrls: ['./descricao-convenio.component.css']
})
export class DescricaoConvenioComponent implements OnInit {

  token: any;
  playLoad: any;

  fotos: any[] = [];
  descricoes: any[] = [];

  idConvenioPessoa = 0;
  aguardeDialog = false;

  constructor(
    private jwtDecoder: JwtHelperService,
    private rota: ActivatedRoute,
    private dashboardService: DashboardService,
    private toasty: ToastrService,
    private erro: ErroNotificacaoService,

  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('access_token_xmanager');
    this.playLoad = this.jwtDecoder.decodeToken(this.token);
    this.idConvenioPessoa = this.rota.snapshot.params.id;

    window.scrollTo(0, 0);
    this.buscarDescricaoConvenio();
    this.buscarDescricoes();
  }

  buscarDescricaoConvenio() {
    this.aguardeDialog = true;
    this.dashboardService.buscarDescricaoConvenio(this.idConvenioPessoa, this.token).subscribe(
      (dados: any) => {
        this.fotos = dados;
        this.aguardeDialog = false;
      },
      (error) => {
        this.erro.handle(error);
        this.toasty.warning('Não foi possível carregar a descrição do convênio. Por favor, tente novamente mais tarde.', 'ATENÇÃO!');
        this.aguardeDialog = false;
      }
    );
  }

  buscarDescricoes() {
    this.aguardeDialog = true;
    this.dashboardService.buscarDescricoes(this.idConvenioPessoa, this.token).subscribe(
      (dados: any) => {
        this.descricoes = dados;
        this.aguardeDialog = false;
      },
      (error) => {
        this.erro.handle(error);
        this.toasty.warning('Não foi possível carregar a descrição do convênio. Por favor, tente novamente mais tarde.', 'ATENÇÃO!');
        this.aguardeDialog = false;
      }
    );
  }

}
